import type { IErrorResponse, UserRateNew } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const usePostRateNew = (): UseMutationResult<
  UserRateNew,
  IErrorResponse,
  { news_id: string; rate: number }
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.postRateNew, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('submitYourScore'),
      });
    },
  });
};

export default usePostRateNew;
